import { WSTableCellProps } from "@wingspanhq/fe-component-library";
import { Payable, WorkLog, WorkLogStatus } from "@wingspanhq/wingspan-api-sdk";
import { WORK_LOG_STATUS_DISCARDED } from "../types";

type GetWorkLogStatusCellPropsParams = {
  workLog: WorkLog;
  payable?: Payable;
};

export function getWorkLogPayerStatusCellProps({
  workLog,
  payable
}: GetWorkLogStatusCellPropsParams): WSTableCellProps {
  // "Discarded" is not in the SDK WorkLogStatus enum yet.
  if ((workLog.status as string) === WORK_LOG_STATUS_DISCARDED) {
    return {
      secondaryText: "Empty auto-submitted work log",
      pill: {
        text: "Discarded",
        theme: "error",
        icon: "exit-circle"
      }
    };
  }

  switch (workLog.status) {
    case WorkLogStatus.APPROVED:
      return {
        // TODO(v3): v3 Payable no longer exposes a friendly invoice number, so
        // the label drops the "#<number>" suffix it showed on v1.
        secondaryText: payable ? "Invoiced" : undefined,
        pill: {
          text: "Approved",
          theme: "success",
          icon: "check-circle"
        }
      };

    case WorkLogStatus.IN_REVIEW: {
      const editingRequested = !!workLog.payeeOwnedData?.comment;
      return {
        secondaryText: editingRequested
          ? "Contractor requested editing"
          : "Awaiting your approval",
        secondaryTextColor: "amber400",
        pill: {
          text: "Action required",
          theme: "warning",
          icon: "alert"
        }
      };
    }

    case WorkLogStatus.IN_PROGRESS:
      return {
        secondaryText: "Awaiting resubmission",
        pill: {
          text: "Awaiting contractor",
          theme: "neutral",
          icon: "time"
        }
      };

    case WorkLogStatus.REJECTED:
      return {
        // TODO(v3): `invoiceId` renamed to `convertedResourceId` on v3 WorkLog.
        secondaryText: workLog.convertedResourceId
          ? "Cancelled invoice"
          : "Not invoiced",
        pill: {
          text: "Rejected",
          theme: "error",
          icon: "block"
        }
      };

    case WorkLogStatus.DRAFT:
    default:
      return {
        pill: {
          text: "Draft",
          theme: "neutral",
          icon: "draft"
        }
      };
  }
}
